<template>
  <div class="container">
    <!-- 须修改 -->
    <!-- <baidu-map
      class="bmView"
      :scroll-wheel-zoom="true"
      :center="location"
      :zoom="zoom"
      @ready="handler"
      ak="xwYMjzVQrbLBGNkYbYN9ifSk3s7io1TE"
    >
      <bm-view class="bm-view"> </bm-view>
      <bm-driving :start="myaddress" :end="target" :auto-viewport="true">
      </bm-driving>
    </baidu-map> -->
    <div id="amView"></div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 12,
      location: { lng: 120.276, lat: 31.883 },
      latstart: "31.898012",
      lngstart: "120.263367",
      myaddress: { lng: 0, lat: 0 },
      target: { lng: 0, lat: 0 },
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      location_center: [120.276, 31.883],
      driving: null,
    };
  },
  created() {
    this.initAMap();
    var that = this;
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        that.queryLocation();
      },
    });
    this.target = { lng: this.$route.query.lng, lat: this.$route.query.lat };
    //this.myaddress = {lng: this.lngstart, lat: this.latstart};
    console.log(this.target);
  },
  methods: {
    handler({ BMap, map }) {},
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "0be51f53e8048ee024013bf11171f342",
      };
      AMapLoader.load({
        key: "c0f480cad7e81b5ff672439bac0174d7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.ToolBar", "AMap.Driving"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("allmap", {
            // 设置地图容器id
            zoom: 12, // 初始化地图级别
            center: this.location_center, // 初始化地图中心点位置
            viewMode: "2D", //设置地图模式
          });
          this.map.addControl(new AMap.ToolBar({ position: "RT" }));
          this.driving = new AMap.Driving({
            policy: 0, //驾车路线规划策略，0是速度优先的策略
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //规划驾车途径
    getDrivingRoute(start, end) {
      this.driving.search(start, end, (status, result) => {});
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryLocation: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryLocation({
          sign: sign,
          params: {
            type: "1",
          },
          success: function (ret) {
            console.log("获取用户定位信息成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
            that.latstart = data.latitude;
            that.lngstart = data.longitude;
            that.myaddress = { lng: that.lngstart, lat: that.latstart };
            that.getDrivingRoute(
              [that.myaddress.lng, that.myaddress.lat],
              [that.target.lng, that.target.lat]
            );
            console.log(that.myaddress);
          },
          error: function (error) {
            console.log("获取用户定位信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
  },
};
</script>
<style scoped>
#amView {
  width: 100%;
  height: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/daohang.vue